import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class IsolinesService {
  constructor() {}

  getIsoLine(poi, poiRegion, mode, range, type): Promise<any> {
    return Promise.resolve({ rows: [] })
  }

  getIsoLineArea(poi, poiRegion, mode, range, type): Promise<any> {
    return Promise.resolve(0)
  }

  getPoisWitinIsoLine(poi, poiRegion, mode, range, type): Promise<any> {
    return Promise.resolve({ total: 0, competitors: 0 })
  }
}
